import React, {CSSProperties, FunctionComponent, useEffect, useState} from "react";
import Linkify from "linkify-react";
import OurPaperModal from "../OurPaperModal/OurPaperModal";
import Button from "@mui/material/Button";
import {ArrowUpRight, TriangleAlert} from "lucide-react";
import {alpha} from "@mui/material/styles";
import {clrYellow} from "../../artistree/artistreeStyles/ArtistreeMaterialUIStyling";

type Body1Props = {
  children?: React.ReactNode,
  breakWord?: boolean,
  className?: string
  id?: string,
  linkify?: boolean,
  linkifyWarnExternal?: boolean,
  title?: string,
  style?: CSSProperties,
  testId?: string,
  noOverflow?: boolean
}

const Body1: FunctionComponent<Body1Props> = (body1Props) => {
  const {
    breakWord,
    className,
    id,
    linkify,
    linkifyWarnExternal,
    title,
    style,
    children,
    testId,
    noOverflow,
  } = body1Props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingHref, setPendingHref] = useState("");

  useEffect(() => {

  }, []);

  const clazzName = className ? className + " body1" : "body1";

  const noOverflowStyle = noOverflow ? {
    overflow: "hidden",
    textOverflow: "ellipsis",
  } : {};

  const linkifyOptions = {
    className: "link",
    target: "_blank",
    rel: "external nofollow noopener",
    ...(linkifyWarnExternal && {
      attributes: {
        onClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
          const href = e.currentTarget.href;
          const { hostname } = new URL(href);
          if (hostname === "artistree.io" || hostname.endsWith(".artistree.io") || hostname === window.location.hostname) return;
          e.preventDefault();
          setPendingHref(href);
          setIsModalOpen(true);
        }
      }
    })
  };

  return (
    <>
      <p id={id} title={title} className={clazzName + (breakWord ? " break-word" : "")}
         style={{...style, ...noOverflowStyle}}
         data-testid={testId}>
        {linkify ?
         <Linkify options={linkifyOptions}>{children}</Linkify>
                 :
         children}
      </p>
      {linkifyWarnExternal &&
        <OurPaperModal parentToggle={isModalOpen}
                       setParentClose={() => setIsModalOpen(false)}
                       overrideModalStyle={{maxWidth: "380px"}}
                       leftSideElement={<h6 className="h6point5 semi-bold">You are leaving Artistree</h6>}
        >
          <div className="padding-bottom left-text">
            <Body1>Be sure to only open links you trust.</Body1>
          </div>
          <div className="padding-bottom"/>
          <div className="padding-self light-bordered-default-text pretty-text-wrap none-selectable flex-row-gap"
               style={{border: "1px solid " + clrYellow, backgroundColor: alpha(clrYellow, 0.1)}}>
            <TriangleAlert style={{color: clrYellow, flexShrink: 0, alignSelf: "flex-start"}}/>
            <Body1 className="left-text">
              Scammers may pose as Artistree. We will never ask for your password or payment information through requests or messages.
            </Body1>
          </div>
          <div className="padding-block-self"/>
          <div className="flex-row-half-gap padding-top">
            <Button fullWidth={true}
                    onClick={() => setIsModalOpen(false)}
                    variant="outlined">
              Go back
            </Button>
            <Button color="primary"
                    fullWidth={true}
                    endIcon={<ArrowUpRight/>}
                    onClick={() => {
                      window.open(pendingHref, "_blank", "noopener,noreferrer");
                      setIsModalOpen(false);
                    }}
                    variant="contained">
              Open link
            </Button>
          </div>
        </OurPaperModal>
      }
    </>
  )
}

export default Body1;
